import type { CompanyProfileLinkState } from "@/shared/utils/companyProfileLink.util";

export const COLLABORATIONS_RETURN_TO = "/collaborations";
export const DISCOVERY_RETURN_TO = "/my-discovery";

export type WorkspaceBackTarget = {
  path: string;
  label: string;
};

function pathnameOf(returnTo: string): string {
  const trimmed = returnTo.trim();
  if (!trimmed) return "/";
  if (trimmed.startsWith("/")) {
    return trimmed.split("?")[0] || "/";
  }
  try {
    return new URL(trimmed, "http://local").pathname;
  } catch {
    return trimmed.split("?")[0] || "/";
  }
}

/** Human-readable back label from a return path (query string ignored). */
export function workspaceBackLabelForPath(returnPath: string): string {
  const pathname = pathnameOf(returnPath);

  if (pathname === "/dashboard" || pathname.startsWith("/dashboard/")) {
    return "Back to Dashboard";
  }

  if (
    pathname === "/my-discovery" ||
    pathname.startsWith("/my-discovery/") ||
    pathname === "/discover" ||
    pathname.startsWith("/discover/")
  ) {
    return "Back to Discovery";
  }

  if (pathname === COLLABORATIONS_RETURN_TO) {
    return "Back to Collaborations";
  }

  if (pathname === "/shortlist" || pathname.startsWith("/shortlist/")) {
    return "Back to Shortlist";
  }

  return "Back";
}

/** Resolve workspace back navigation from router location state. */
export function resolveWorkspaceBackNavigation(
  discoverReturnTo: string | undefined,
  defaultReturnTo: string,
): WorkspaceBackTarget {
  const path = discoverReturnTo?.trim() || defaultReturnTo;
  return {
    path,
    label: workspaceBackLabelForPath(path),
  };
}

export function workspaceBackLinkState(returnTo: string): CompanyProfileLinkState {
  return { discoverReturnTo: returnTo };
}
